import React, { useState } from 'react'
import { inject, observer } from 'mobx-react'
import * as Yup from 'yup'
import styled from 'styled-components'
import { Formik, Form, Field, ErrorMessage } from 'formik'

import services from '../services'
import { APIURL } from '../../constants'
import { forgotPasswordSchema } from '../advisor/ChangePassword'
import PageTitle from '../common/PageTitle'
import LoadingButton from '../common/LoadingButton'

const FormWrapper = styled.div`
  max-width: 350px;
`

const H2 = styled.h2`
  font-size: 1.5rem;
  text-align: center;
  margin: 20px 0;
  font-weight: 400;
`

const Row = styled.div`
  margin: 20px 0;
`

const RowCenter = styled(Row)`
  text-align: center;
`

const ErrorMessageWrapper = styled.div`
  color: red;
  padding: 10px 0;
`

const ForgotPassword = inject('store')(
  observer(({ store }) => {
    const [success, setSuccess] = useState(false)
    const { siteData } = store
    const title = `${siteData.get('name')} - Password Reset`
    return (
      <div>
        <PageTitle title={title} />
        <FormWrapper>
          <Formik
            initialValues={{ email: '' }}
            validationSchema={Yup.object(forgotPasswordSchema)}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              setSubmitting(true)
              const errorMsg =
                'Unable to reset password at this time. Please try again later.'
              try {
                const data = {
                  email: values.email
                }
                const response = await services.post_v2(
                  APIURL.API_USER_FORGOT_PASSWORD,
                  data
                )
                if (response.statusCode === 200) {
                  setSuccess(true)
                } else {
                  setErrors({ email: errorMsg })
                }
              } catch (e) {
                console.error(e)
                setErrors({ email: errorMsg })
              }
              setSubmitting(false)
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                {success && (
                  <div>
                    <H2>An email has been sent to you!</H2>
                    <RowCenter>
                      If the email you provided is in our database, an email has
                      been sent to it. Please click the link to reset your
                      password.
                    </RowCenter>
                  </div>
                )}
                {!success && (
                  <div>
                    <H2>Reset your Password</H2>
                    <Row>
                      <Field
                        type="email"
                        name="email"
                        placeholder="Email"
                        className="form-control"
                        autoFocus
                      />
                      <ErrorMessage
                        name="email"
                        component={ErrorMessageWrapper}
                      />
                    </Row>
                    <RowCenter>
                      <LoadingButton
                        text="Submit"
                        type="submit"
                        disabled={isSubmitting}
                        isLoading={isSubmitting}
                      />
                    </RowCenter>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </FormWrapper>
      </div>
    )
  })
)

export default ForgotPassword
